import React from "react"
import { barWrapper, barInner } from "./ProgressBar.css"

// We could technically replace div with the progress element, it'd involve more changes that I don't think are worth it but this could potentially be done at some point
export const ProgressBar: React.FC<{
  percentProgress: string
  ariaLabel: string
}> = ({ percentProgress, ariaLabel }) => {
  return (
    <div className={barWrapper}>
      <div
        role={"progressbar"}
        aria-valuetext={percentProgress}
        aria-label={ariaLabel}
        className={`${barInner} progress-inner`}
        style={{ width: percentProgress }}
      />
    </div>
  )
}
